<template>
    <div class="d-flex justify-content-between w-100 p-3">
        <nav-button
            :key="`back-nav-${currentPage}`"
            class="indexed-nav__nav-button"
            type="back"
            v-if="currentPage !== 1"
            @click="handlePrev"
        />
        <div v-else class="indexed-nav__placeholder" />
        <div class="d-flex align-items-center">
            <div 
                v-for="i in pages"
                :key="i"
                class="indexed-nav__dot mx-1"
                :class="i === currentPage ? 'indexed-nav__dot--active' : ''"
                @click="handleClick(i)"
            >
            </div>
        </div>
        <nav-button
            :key="`next-nav-${currentPage}`"
            class="indexed-nav__nav-button"
            @click="handleNext"
            v-if="currentPage !== pages"
        />
        <div v-else class="indexed-nav__placeholder" />
    </div>
</template>
<script>
import navButton from '@/components/ui/navButton'

export default {
    name: 'indexedNav',
    components: {
        'nav-button': navButton
    },
    props: {
        pages: {
            type: Number,
            default: 1,
        },
        currentPage: {
            type: Number,
        },
    },

    methods: {
        handleNext() {
            if(this.currentPage < this.pages) {
                this.$emit('next')
            }
        },
        handlePrev() {
            if(this.currentPage > 1) {
                this.$emit('prev')
            }
        },
        handleClick(pageNumber) {
            this.$emit('click', pageNumber)
        }
    }
}
</script>
<style lang="scss">
.indexed-nav__dot {
    height: 10px;
    width: 10px;
    background-color: $base_grey-2;
    border-radius: 50%;
    cursor: pointer;
    &--active {
        background-color: $bq-green;
    }
}

.indexed-nav__nav-button {
    height: 50px;
    width: 50px;
}

.indexed-nav__placeholder {
    width: 50px;
}
</style>